const skills = {
    tecnologias: {
        title: 'Tecnologia',
        option: ['Vanilla JS', 'React JS', 'Python', 'Flask', 'CSS', 'HTML', 'Ruby on Rails', 'C++', 'Git', 'Sass']
    },
    Soft:{
        title: 'Soft Skills',
        option: ['Liderança', 'Proatividade', 'Criatividade', 'Trabalho em equipe', 'Comunicativo']
    },
    interesses: {
        title: 'Interresses',
        option: ['Engenharia de Software', 'Metodologia Ágil', 'Gamificação', 'Empreededorismo', 'Desenvolvimento Web', 'UX/UI', 'Educação']
    }
}

export default skills;